module.exports = __webpack_public_path__ + "media/dog-personality-traits/toy-squeaker-ae5233b0.svg";